<script>

    import { onMount,beforeUpdate } from "svelte";

	export let appdesc;
	export let connections;

	$: currentReoucreURL ='';
	let currentRessourceType;
	$: sourcecode=((appdesc && appdesc.label)? 'Select a resource for '+appdesc.label : 'Select a resource');

    $: ID = (appdesc && appdesc.uri) ? appdesc.uri
        .replace(/http:/,'')
        .replace(/:/g,'')
        .replace(/\//g,'')
        .replace(/\./g,'')
        .replace(/\_/g,'') : '';

     onMount(async function() {
         sourcecode ='';
     });

     async function fetchSource (sourceURL, type) {

        currentReoucreURL = sourceURL;
        currentRessourceType = type;
        sourcecode= 'Loading ...';
        fetch(sourceURL)
         .then (async (response) => {
             sourcecode = await response.text();
             return true;
         })
         .catch( a => sourcecode =' error loading content: '+a)

     }

     async function openInWindow () {

         if (currentRessourceType ==='text') {
            var myWindow = window.open('', "_blank" , "toolbar=yes,scrollbars=yes,resizable=yes,top=300,left=300,width=800,height=400");
            myWindow.document.open();
            myWindow.document.write('<PLAINTEXT>'+sourcecode);
         } else {
             window.open ( currentReoucreURL, "", "toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=200,width=800,height=400");
         }

      }

    async function showAppModelInWindow (appURI, variant) {
        if (!variant) variant = root;

        var appURL = connections.mimesisCombinedUI_URL
            + '?applicationURI='+appURI
            + '&variantURI='+appURI+'/variants%23'+variant;

        fetchSource ( appURL );

    }

    function showAppResourceInWindow (appURI, resource ) {

        var appURL = connections.mimesisResources_URL
        + '?resourceURL=' +appURI+ '/' + resource;
        fetchSource ( appURL );
    }

    function showAppOntologyInWindow (appURI ) {

        var appURL = connections.mimesisAppModelOntology_URL
            + '?applicationURI=' +appURI;
        fetchSource ( appURL );
    }


</script>

<style>
.btn {
    margin : .2em;
    }
.card {
    padding:1em;
    height:100%;
    overflow: auto;
}
.card h3 {
    padding:0 0 1em 0;
    margin:0em;
}

</style>


<div class=" jumbotron card " style="flex-flow: column;" >
<div class="container">
    {#if appdesc}
         <div class="row text-center">
            <h3>  {@html appdesc.label} {#if appdesc.subtitle}<br><small>{@html appdesc.subtitle}</small>{/if}</h3>
             <span style="text-align:left;">
                 <div>
                     {@html appdesc.description}
                 </div>

             </span>
         </div>
        {#if appdesc.resources}
            <div class="row">
                {#each appdesc.resources as res}

                    <div class="btn btn-info col-lg-5"
                     on:click={ () => {fetchSource(res.url, res.type); openInWindow();}}>{@html res.label}
                    </div>
                    <div class="col-lg-8">
                        {@html res.description}
                    </div>
                {/each}
             </div>
        {/if}
    {:else}
        <div class="row text-center">
            <div>
                Please Select Entry
            </div>
        </div>

    {/if }
</div>
</div>
